import { FC, useEffect, useState } from 'react';
import { toastify, Typography } from '#ui-kit';
import { TypographySize, TypographyTag } from '#ui-kit.types';
import { removeEmptyFields } from '#utils';
import { ErrorsService } from '#services/errors';
import { GetOrdersDto } from '#services/orders/dto/get-orders.dto';
import { OrderDeliveryTypeEnum } from '#services/orders/enums/order-delivery-type.enum';
import { OrderInternalStatusEnum } from '#services/orders/enums/order-internal-status.enum';
import { ExternalStatusEnum } from '#services/orders/responses/orders.response';
import { CheckboxGroup } from '../CheckboxGroup';
import { OrderInternalStatusLabels, OrderPOSStatusLabels } from './constants';
import { FormContainer, FormItem, SelectedErrorLabel } from './style';
import { colors, Input, Label, Section, Select } from 'styles';
import { LanguageISO2Enum } from 'types';

type FilterFormPropsType = {
  handleCheckboxGroupChange: (name: string, selectedValues: string[]) => void;
  handleFormSubmit: (event: React.FormEvent) => void;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSelectChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleDeleteSelectedError: (name: string) => void;
  handleDeleteSelectedErrorCategory: (id: number) => void;
  filters: Omit<GetOrdersDto, 'page' | 'size'>;
};

export const FilterForm: FC<FilterFormPropsType> = ({
  handleCheckboxGroupChange,
  handleFormSubmit,
  handleInputChange,
  handleDeleteSelectedError,
  handleSelectChange,
  filters,
}) => {
  const [errorsTranslations, setErrorsTranslations] = useState<
    Record<string, string>
  >({});
  const [errors, setErrors] = useState<string[]>([]);
  const [searchString, setSearchString] = useState<string>('');

  const errorsService = new ErrorsService();

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setSearchString(event.target.value);

  // eslint-disable-next-line no-unused-vars
  // const getErrorCategories = async () => {
  //   try {
  //     const result = await errorsService.getErrorCategoryList();

  //     const categoriesMap = result.data.reduce((acc, category) => {
  //       acc[String(category.id)] = category.title;

  //       return acc;
  //     }, {} as Record<string, string>);

  //     setErrorCategoriesMap(categoriesMap);
  //   } catch {
  //     toastify.error('Не удалось получить список категорий ошибок');
  //   }
  // };

  const getErrors = async () => {
    try {
      const filter = removeEmptyFields({
        searchString,
      });

      const result = await errorsService.getFilteredErrors({
        page: 1,
        size: 10,
        language: LanguageISO2Enum.RU,
        ...filter,
      });

      setErrorsTranslations((old) => {
        for (const error of result.data) {
          old[error.code] = error.message;
        }

        return old;
      });

      const errorCodes = result.data.map((error) => error.code);

      setErrors(errorCodes);
    } catch {
      toastify.error('Не удалось получить список ошибок');
    }
  };

  // useEffect(() => {
  //   getErrorCategories();
  // }, []);

  useEffect(() => {
    getErrors();
  }, [searchString]);

  return (
    <Section>
      <FormContainer onSubmit={handleFormSubmit}>
        {/* Номер заказа */}
        <FormItem>
          <Label htmlFor="orderNumber">Номер заказа</Label>
          <Input
            type="text"
            id="orderNumber"
            name="orderNumber"
            value={filters.orderNumber || ''}
            onChange={handleInputChange}
          />
        </FormItem>

        {/* Номер телефона пользователя */}
        <FormItem>
          <Label htmlFor="userPhoneNumber">Номер телефона пользователя</Label>
          <Input
            type="text"
            id="userPhoneNumber"
            name="userPhoneNumber"
            value={filters.userPhoneNumber || ''}
            onChange={handleInputChange}
          />
        </FormItem>

        {/* Дата создания с */}
        <FormItem>
          <Label htmlFor="createdAtFrom">Дата создания с</Label>
          <Input
            type="date"
            id="createdAtFrom"
            name="createdAtFrom"
            value={filters.createdAtFrom || ''}
            onChange={handleInputChange}
          />
        </FormItem>

        {/* Дата создания по */}
        <FormItem>
          <Label htmlFor="createdAtTo">Дата создания по</Label>
          <Input
            type="date"
            id="createdAtTo"
            name="createdAtTo"
            value={filters.createdAtTo || ''}
            onChange={handleInputChange}
          />
        </FormItem>

        {/* Способ доставки */}
        <FormItem
          style={{
            width: '150px',
          }}
        >
          <Label htmlFor="orderNumber">Способ получения</Label>
          <Select
            id="deliveryTypeSelect"
            name="deliveryType"
            value={filters.deliveryType}
            onChange={handleSelectChange}
          >
            <option value="">Выберите способ получения</option>
            <option value={OrderDeliveryTypeEnum.delivery}>Доставка</option>
            <option value={OrderDeliveryTypeEnum.pickup}>Самовывоз</option>
          </Select>
        </FormItem>

        {/* Внутренний статус */}
        <FormItem style={{ flexBasis: '100%' }}>
          {' '}
          {/* Занимает всю ширину */}
          <Label>Внутренний статус</Label>
          <CheckboxGroup
            name="internalStatus"
            options={Object.values(OrderInternalStatusEnum)}
            translations={OrderInternalStatusLabels}
            selectedOptions={filters.internalStatus || []}
            onChange={handleCheckboxGroupChange}
          />
        </FormItem>

        {/* Внешний статус */}
        <FormItem style={{ flexBasis: '100%' }}>
          {' '}
          {/* Занимает всю ширину */}
          <Label>Внешний статус</Label>
          <CheckboxGroup
            name="posStatus"
            options={Object.values(ExternalStatusEnum)}
            translations={OrderPOSStatusLabels}
            selectedOptions={filters.posStatus || []}
            onChange={handleCheckboxGroupChange}
          />
        </FormItem>

        {/* <Section style={{ width: '100%' }}>
          <Label>Выбранные категории ошибок</Label>
          {filters.errorCategoryIds?.length ? (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
              {filters.errorCategoryIds.map((categoryId) => (
                <SelectedErrorLabel
                  onClick={() => handleDeleteSelectedErrorCategory(categoryId)}
                >
                  {'⛌ ' + errorCategoriesMap[categoryId]}
                </SelectedErrorLabel>
              ))}
            </div>
          ) : (
            <Typography
              size={TypographySize.xs}
              tag={TypographyTag.p}
              style={{
                color: `${colors.black._100}`,
              }}
            >
              Ничего не выбрано
            </Typography>
          )}
        </Section> */}

        <Section style={{ width: '100%' }}>
          <Label>Выбранные ошибки</Label>
          {filters.errorMessageCodes?.length ? (
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px',
              }}
            >
              {filters.errorMessageCodes.map((error) => (
                <SelectedErrorLabel
                  onClick={() => handleDeleteSelectedError(error)}
                >
                  {'⛌ ' + errorsTranslations[error]}
                </SelectedErrorLabel>
              ))}
            </div>
          ) : (
            <Typography
              size={TypographySize.xs}
              tag={TypographyTag.p}
              style={{
                color: `${colors.black._100}`,
              }}
            >
              Ничего не выбрано
            </Typography>
          )}
        </Section>

        {/* Категории ошибок */}
        {/* <FormItem style={{ flexBasis: '100%' }}>
          <Label>Выберите категории ошибок</Label>
          <CheckboxGroup
            name="errorCategoryIds"
            options={Object.keys(errorCategoriesMap)}
            selectedOptions={
              filters.errorCategoryIds?.map((category) => String(category)) ||
              []
            }
            onChange={handleCheckboxGroupChange}
            translations={errorCategoriesMap}
          />
        </FormItem> */}

        {/* Причина отмены */}
        <FormItem style={{ flexBasis: '100%' }}>
          <Label>Поиск ошибок</Label>
          <Input
            type="text"
            id="searchString"
            name="searchString"
            value={searchString}
            onChange={handleSearchChange}
            style={{ marginBottom: '10px' }}
          />
          <CheckboxGroup
            name="errorMessageCodes"
            options={errors}
            selectedOptions={filters.errorMessageCodes || []}
            onChange={handleCheckboxGroupChange}
            translations={errorsTranslations}
          />
        </FormItem>
      </FormContainer>
    </Section>
  );
};
